export default __webpack_public_path__ + "static/media/clockIcon.762e3c21.svg";